import { render } from "./QuotationRequest.vue?vue&type=template&id=2432536c"
import script from "./QuotationRequest.vue?vue&type=script&lang=js"
export * from "./QuotationRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/QuotationRequest.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2432536c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2432536c', __exports__)) {
    api.reload('2432536c', __exports__)
  }
  
  module.hot.accept("./QuotationRequest.vue?vue&type=template&id=2432536c", () => {
    api.rerender('2432536c', render)
  })

}


export default __exports__